import type MainWindowCuiLayout from './MainWindowCuiLayout';
import type { HeaderTab, GHeaderTab } from '../aras/startup/headerTabs';

const updateTabs = (
	setState: MainWindowCuiLayout['setState'],
	type: 'dockTabs' | 'mainTabs'
) => {
	return (
		newTabs: Array<string>,
		tabId: string,
		tabData: Partial<HeaderTab>
	) => {
		setState((state: MainWindowCuiLayout['state']) => {
			state.splitScreen[type] = [...newTabs];

			const tabRemoved = !newTabs.includes(tabId);
			if (tabRemoved) {
				delete state.splitScreen.tabs[tabId];
			} else {
				const resultTabData: HeaderTab & {
					layout?: GHeaderTab<'CuiLayout'>['layout'];
				} = {
					...state.splitScreen.tabs[tabId],
					...tabData
				};
				// there is could be an instance of CUI Layout and we shouldn't store it in state
				delete resultTabData.layout;

				state.splitScreen.tabs[tabId] = resultTabData;
			}
		});
	};
};

export default (setState: MainWindowCuiLayout['setState']) => {
	return {
		updateDockedTabs: updateTabs(setState, 'dockTabs'),
		updateUndockedTabs: updateTabs(setState, 'mainTabs'),
		updateSelectedTabs: (
			selectedTabs: MainWindowCuiLayout['state']['splitScreen']['selectedTabs']
		) => {
			setState((state: MainWindowCuiLayout['state']) => {
				state.splitScreen.selectedTabs = selectedTabs;
			});
		},
		navigationPanel: {
			updateVisibility: (newState: boolean) => {
				setState((state) => {
					state.navigationPanel.isVisible = newState;
				});
			}
		}
	};
};
